import React, { useEffect, useState } from 'react'
import { StyleSheet, View, TextInput, TouchableOpacity, FlatList, Text, StatusBar, Image } from 'react-native'
import { FontAwesome } from '@expo/vector-icons'
import { StoresListModel } from '../models/ScheduleModel'
import { StoreItem } from '../StoreItem'
import { useBottomSheet } from '../../customUtils/context/BottomSheetContext'
import { Loader } from '../../customUtils/Components/Loader'
import { schedulesServices } from '../../../../database/schedules.database'
import { distanceInMeters } from '../../customUtils/calculateDistance'
import { useStoreContext } from '../context/store.context'
import { Platform } from 'react-native'
import BottomSheet from '../../BottomSheetWrapper'
const BottomSheetFlatList = Platform.OS !== 'web' ? require('@gorhom/bottom-sheet').BottomSheetFlatList : FlatList
import { dataStore } from '../PerfectStoreVIew'
import theme from '../../../../theme'
import { Ionicons, Feather } from '@expo/vector-icons'
import styles from './SearchStoresStyles'
import { getLanguage } from '../../appBar/context/LocalizationContext'
import { useLoaderSaveStores } from '../../../redux/zustand/loaderSaveStore'

interface SearchStoresI {
    onClickGoStore?: (store: StoresListModel) => void
    selectedSchedule?: any
    initialLocation?: { lat: any; lng: any }
    userLocation?: { lat: any; lng: any }
    campaign?: any
}

export const SearchStores = ({ onClickGoStore, selectedSchedule, initialLocation, campaign, userLocation }: SearchStoresI) => {
    const { languageFile } = getLanguage()

    const [searchStores, setSearchStores] = useState<StoresListModel[]>([])
    const [text, onChangeText] = useState('')
    const { closeBottomSheet } = useBottomSheet()
    const [isLoading, setIsLoading] = useState(true)
    const loaderSaveStores = useLoaderSaveStores()
    const [searchText, setSearchText] = useState('')
    const [filteredStores, setFilteredStores] = useState([])
    const [dots, setDots] = useState('')

    // useEffect(() => {
    //     const interval = setInterval(() => {
    //         setDots((prevDots) => {
    //             if (prevDots.length >= 3) {
    //                 return '' // Resetea a cero después de 3 puntos
    //             } else {
    //                 return prevDots + '.' // Añade un punto
    //             }
    //         })
    //     }, 400) // Cambia la velocidad aquí (500ms entre cambios)

    //     return () => clearInterval(interval) // Limpia el intervalo al desmontar
    // }, [])

    const filterStores = (text: string) => {
        let stores: StoresListModel[] = []
        if (text && text.trim().length > 0) {
            stores = searchStores.filter(
                (store) =>
                    (store.name?.toLowerCase() ?? '').includes(text.toLowerCase()) ||
                    (store.address?.toLowerCase() ?? '').includes(text.toLowerCase()) ||
                    (store.code?.toLowerCase() ?? '').includes(text.toLowerCase()),
            )
        } else {
            stores = searchStores
        }

        return stores
    }
    //let filteredStores: StoresListModel[] = filterStores(text)

    const handleGoToStore = (store: StoresListModel) => {
        onClickGoStore(store)
        closeBottomSheet(true)
    }

    const getAllStores = async () => {
        console.log('-------->>>> Entro al get all')
        try {
            setIsLoading(true)

            if (selectedSchedule) {
                const radius = 20000000 // Radio de búsqueda en metros (5 km)
                let newStores = await schedulesServices.searchStoresFromSchedule(
                    0,
                    1000,
                    selectedSchedule._id,
                    -1,
                    initialLocation.lat,
                    initialLocation.lng,
                    radius,
                    campaign.schedule_free,
                    null,
                )
                newStores.forEach((store) => {
                    store.distance = distanceInMeters(userLocation.lat, userLocation.lng, store.lat, store.lng)
                })
                // setSearchStores(newStores)
                setFilteredStores(newStores)
                // setSearchStores(stores)
            }
        } catch (error) {
            console.error('96 --- getTagTodo: error: ', error)
        } finally {
            setIsLoading(false)
        }
    }
    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            if (searchText && searchText != '') {
                schedulesServices
                    .searchStoresByText(selectedSchedule._id, searchText)
                    .then((stores) => {
                        console.log('--- stores found: ', stores.length)
                        setFilteredStores(stores)
                    })
                    .catch((error) => console.error(error))
            } else {
                getAllStores()
            }
        }, 500) // Debounce de 500ms

        return () => clearTimeout(delayDebounceFn)
    }, [searchText])

    // useEffect(() => {
    //     getAllStores()
    // }, [page])

    if (isLoading) {
        return <Loader />
    }

    return (
        <View style={styles.container}>
            {/* <StatusBar backgroundColor={'rgba(0, 0, 0, 0.7)'} barStyle='dark-content' /> */}

            <View style={styles.containerFinder}>
                <View style={styles.inputBlock}>
                    <TextInput
                        style={styles.input}
                        onChangeText={setSearchText}
                        placeholder={languageFile.search_store}
                        placeholderTextColor={theme.colors.mediumGray}
                    />
                    <Feather name='search' size={24} color={theme.colors.textPrimary} />
                </View>
                {/* <Text>{filteredStores.length} resultados</Text> */}
            </View>
            {/* {loaderSaveStores.isLoader && loaderSaveStores.total_stores != null && (
                <View style={styles.containerLoading}>
                    <Text style={[styles.loading, { fontWeight: '600' }]}>Cargando tiendas{dots} </Text>
                    <Text style={styles.loading}>
                        {loaderSaveStores.stores_downloaded}/{loaderSaveStores.total_stores}
                    </Text>
                </View>
            )} */}

            {isLoading ? (
                <Loader />
            ) : (
                <View style={styles.containerFlex}>
                    {filteredStores && filteredStores.length > 0 ? (
                        <BottomSheetFlatList
                            style={styles.flatList}
                            data={filteredStores}
                            maxToRenderPerBatch={20}
                            keyExtractor={(item, index) => index.toString()}
                            horizontal={false}
                            showsVerticalScrollIndicator={false}
                            scrollEnabled={true}
                            renderItem={({ item: stores }) => <StoreItem key={stores._id} store={stores} onClickGoStore={handleGoToStore} />}
                            numColumns={1}
                            onEndReachedThreshold={1}
                        />
                    ) : (
                        <View style={styles.containerNoResults}>
                            {/* <StatusBar backgroundColor={'rgba(0, 0, 0, 0.7)'} barStyle='dark-content' /> */}
                            <Image style={styles.image} source={require('../../../../assets/noSearchResultsStores.png')} />
                            <Text style={styles.title}>{languageFile.no_results_for_your_search}</Text>
                            <Text style={styles.description}>{languageFile.find_another_store}</Text>
                        </View>
                    )}
                </View>
            )}
        </View>
    )
}
